import { Auth } from 'aws-amplify'

export const cognitoConfirmSignUp = async (username, code) => {
  let result = {
    isError: false,
  }

  try {
    await Auth.confirmSignUp(username, code)
  } catch (error) {
    result.isError = true
    result.data = error
  }

  return result
}
